import React, { useState, useEffect, useRef } from "react";
import { Grid, Box, MenuItem, InputAdornment } from "@mui/material";
import dayjs from 'dayjs';
import SubHeader from "../../../components/SubHeader";
import StyledDialog from '../../../components/Dialog';
import ScreenSideBar from "../../../components/ScreenSideBar";
import ClientBasicInfo from "../../../client-basic-info";
import ClientContactInfo from "../../../client-contact-info";
import ClientFinancialInfo from "../../../client-financial-info";
import SelectorTextField from "../../../components/SelectorTextField";
import TextField from "../../../components/TextField";
import CustomDatePicker from "../../../components/DatePicker";
import AttachmentList from "../../attachments/components/attachment-list";
import DocketTable from '../../dockets/docket-list';
import DataTable from "../../../components/DataTable";
import NoteTable from "../../../notes";
import Backdrop from '../../../components/elements/Loader';
import StyledModal from '../../../components/Modal';
import StyledButton from '../../../components/elements/StyledButton';
import { useAccount, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { GetClientFileById, GetAllPreferredCounsels, GetPreferredCounselFromCrm } from "../../../services/client-file.service";
import { GetInteractionMetaData, GetInteractionById, UpdateInteraction, SubmitInteraction, MarkInteractionForReview, DeleteInteraction, UpdateCrmServiceDecisionDutyCounselTriage } from "../../../services/interaction-service";
import { tokenRequest } from "../../../auth/authConfig";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import appconfig from '../../../appConfig';
import Badge from 'react-bootstrap/Badge';
import { useAuthorization } from "../../../hooks/useAuthorization";
import * as Constants from "../../../helper/constants";
import { useAppInsightsContext, useTrackEvent } from "@microsoft/applicationinsights-react-js";
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { GetClientDetailNotes } from "../../../services/note-service";
import { FetchLookupData } from "../../../services/client-file.service";
import { useNavigationParameters } from "../../../hooks/useNavigationParameters";
import { IoWarning } from "react-icons/io5";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import NewPreferredCounselAutocomplete from './NewPreferredCounselAutocomplete';
import DisclosureInformationSection, { YesOrNoQuestion } from './DisclosureInformationSection';
import { useDisclosureInformation } from './useDisclosureInformation';
import {
    COLORS, FIELD_SX, INVALID_DATE_FORMAT_MESSAGE, SECTION_BODY_SX, SECTION_TITLE_SX, COLUMN_SX,
    columnWithLeftBorderSx, sectionContainerSx,
} from './pageFields';
import { useTouchDevice } from "../../../hooks/useTouchDevice";

// On the new layout Disclosure Status replaces some Interaction Statuses (the API's metadata names them); the API
// refuses choosing one there, and a held one is shown but cannot be chosen again
const STATUS_REPLACED_HINT = "Replaced by Disclosure Status. Can't select this Status again if you change it.";
const STATUS_EXPIRED_HINT = "Expired Status. Can't select this Status again if you change it.";

export default function Interaction() {
    const isAuthenticated = useIsAuthenticated();
    const [canCreate, canRead, canUpdate, canDelete] = useAuthorization();
    const [appendExistingNavigationParameters, removeDuplicatedNavigationParameters, prepareNavigationParameters] = useNavigationParameters();
    const { instance, accounts } = useMsal();
    const currentAccount = instance.getActiveAccount();
    const account = useAccount(accounts[0] || {});
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const [interactionId, setInteractionId] = useState(Number(searchParams.get(Constants.IDQUERYSTRINGPARAM)));
    const [clientFileId, setClientFileId] = useState(Number(searchParams.get(Constants.CLIENTFILEIDQUERYSTRINGPARAM)));
    const [interactionCrmId, setInteractionCrmId] = useState("");
    const [clientFileCrmId, setClientFileCrmId] = useState("");
    const [isActive, setIsActive] = useState("");
    const [isConflicted, setIsConflicted] = useState(false);
    const screenSideBarList = ['Client Basic Information', 'Client Contact Information', 'Client Financial Information', 'Lawyer Information', 'Docket Details', 'Interaction Notes'];
    const { isTablet } = useTouchDevice();
    const [screenSideBarKey, setScreenSideBarKey] = useState(screenSideBarList[0]);
    const [formStatus, setFormStatus] = useState("");
    const [formStatusError, setFormStatusError] = useState("");
    const [originalAssignedTo, setOriginalAssignedTo] = useState("");
    const [assignedOn, setAssignedOn] = useState("");
    const [assignedTo, setAssignedTo] = useState("");
    const [assignedToError, setAssignedToError] = useState(false);
    const [assignedBy, setAssignedBy] = useState("");
    const [originalAssignedBy, setOriginalAssignedBy] = useState("");
    const [dutyCounselType, setDutyCounselType] = useState("");
    const [dutyCounselTypeError, setDutyCounselTypeError] = useState("");
    const [adultOrYouth, setAdultOrYouth] = useState("");
    const [adultOrYouthError, setAdultOrYouthError] = useState("");
    // The Disclosure Information section (Feature 8459) and the three disclosure questions, on either layout
    const disclosure = useDisclosureInformation();
    const [dateOfFirstAttemptedContact, setDateOfFirstAttemptedContact] = useState("");
    const [isdateOfFirstAttemptedContactInvalid, setIsdateOfFirstAttemptedContactInvalid] = useState(false);
    const [nextActionDate, setNextActionDate] = useState("");
    const [isNextActionDateInvalid, setIsNextActionDateInvalid] = useState(false);
    const [disableDateOfFirstAttemptedContact, setDisableDateOfFirstAttemptedContact] = useState(false);
    const [firstCourtDate, setFirstCourtDate] = useState("");
    const [firstCourtDateError, setFirstCourtDateError] = useState(false);
    const [isFirstCourtDateInvalid, setIsFirstCourtDateInvalid] = useState(false);
    const [disableFirstCourtDate, setDisableFirstCourtDate] = useState("");
    const [isInCustody, setIsInCustody] = useState("");
    const [isInCustodyError, setIsInCustodyError] = useState(false);
    const [financialStatus, setFinancialStatus] = useState("");
    const [serviceDecisionNumber, setServiceDecisionNumber] = useState("");
    const [serviceDecisionNumberError, setServiceDecisionNumberError] = useState("");
    const [assesmentOutcome, setAssesmentOutcome] = useState("");
    const [notes, setNotes] = useState("");
    const [clientInteractionNotes, setClientInteractionNotes] = useState([]);
    const [assesmentOutcomeDate, setAssesmentOutcomeDate] = useState("");
    const [imprisonmentLikelihood, setImprisonmentLikelihood] = useState("");
    const [imprisonmentLikelihoodError, setImprisonmentLikelihoodError] = useState(false);
    const [doesClientHavePreferredCounsel, setDoesClientHavePreferredCounsel] = useState(null);
    const [clientsPreferredLawyer, setClientsPreferredLawyer] = useState("");
    const [clientsPreferredLawyer2, setClientsPreferredLawyer2] = useState("");
    const [clientsPreferredLawyer3, setClientsPreferredLawyer3] = useState("");
    const [newPreferredCounsel, setNewPreferredCounsel] = useState("");
    const [preferredCounselOptions, setPreferredCounselOptions] = useState([]);
    const [displayedOptionsCount, setDisplayedOptionsCount] = useState(50); // Track how many options to display
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [dockets, setDockets] = useState([]);
    const [createdOn, setCreatedOn] = useState("");
    const [createdBy, setCreatedBy] = useState("");

    const [formStatuses, setFormStatuses] = useState([]);
    const [dutyCounselTypes, setDutyCounselTypes] = useState([]);
    const [adultOrYouthStatuses, setAdultOrYouthStatuses] = useState([]);

    const [assesmentOutcomes, setAssesmentOutcomes] = useState([]);
    const [imprisonmentLikelihoods, setImprisonmentLikelihoods] = useState([]);
    const yesOrNoSelectionList = [{ selectionItemId: "0", label: "Yes", value: true }, { selectionItemId: "1", label: "No", value: false },];

    const [topmyfilesduedate, setTopmyfilesduedate] = useState(searchParams.get("topmyfilesduedate") === "true" ? true : false);
    const [topfilestobeassignedduedate, setTopfilestobeassignedduedate] = useState(searchParams.get("topfilestobeassignedduedate") === "true" ? true : false);
    const [topassignedfilesduedate, setTopassignedfilesduedate] = useState(searchParams.get("topassignedfilesduedate") === "true" ? true : false);
    const [myfilesduedate, setMyfilesduedate] = useState(searchParams.get("myfilesduedate") === "true" ? true : false);
    //const [topfilestobeassignedduedate, setTopfilestobeassignedduedate] = useState(searchParams.get("topfilestobeassignedduedate") === "true"? true: false);
    const [assignedfilesduedate, setAssignedfilesduedate] = useState(searchParams.get("assignedfilesduedate") === "true" ? true : false);
    const [backPage, setBackPage] = useState(searchParams.get("page"));


    const [assignedToList, setAssignedToList] = useState([]);

    const [isLoading, setIsLoading] = useState(true);

    const NAVIGATEURL = "/client-file?id=";
    const apiServerUrl = appconfig.API_SERVER_URL;
    const [contactMethods, setContactMethods] = useState([]);

    const [crmId, setCrmId] = useState(searchParams.get("crmId"));
    const [firstName, setFirstName] = useState(searchParams.get("firstname"));
    const [middleName, setMiddleName] = useState(searchParams.get("middlename"));
    const [lastName, setLastName] = useState(searchParams.get("lastname"));
    const [dateOfBirth, setDateOfBirth] = useState(searchParams.get("dateofbirth"));
    const [clientBasicInfo, setClientBasicInfo] = useState("");
    const [clientContactInfo, setClientContactInfo] = useState("");
    const [pagecount, setPagecount] = useState(searchParams.get("pagecount"));
    const [saveClicked, setSaveClicked] = useState(false);
    const [canAssignedTo, setCanAssignedTo] = useState(false);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [isInitiallyDisabled, setIsInitiallyDisabled] = useState(false);
    const [isDokcetDisabled, setIsDokcetDisabled] = useState(false);
    const [isShowAttachments, setIsShowAttachments] = useState(true);
    const [isFcUpdated, setIsFcUpdated] = useState(false);
    const [openFEGModal, setOpenFEGModal] = useState(false);
    const [trackEvents, setTrackEvents] = useState("");
    const appInsights = useAppInsightsContext();
    const trackEventsInsights = useTrackEvent(appInsights, "Interaction : ", trackEvents);

    const [statuses, setStatuses] = useState([]);
    const [status, setStatus] = useState("");
    const [statusError, setStatusError] = useState(false);
    const [isStatusExpired, setIsStatusExpired] = useState(false);
    const [statusIdsReplacedByDisclosureStatus, setStatusIdsReplacedByDisclosureStatus] = useState([]);

    // Helper function to determine field visibility based on preferred counsel scenarios
    const getPreferredCounselVisibility = () => {
        // During loading or when doesClientHavePreferredCounsel is not set, return default visibility
        if (!doesClientHavePreferredCounsel) {
            return {
                showDoesClientHavePreferredCounsel: true,
                showClientPreferredLawyer: false,
                showClientPreferredLawyer2: false,
                showClientPreferredLawyer3: false
            };
        }
        
        const hasPreferredCounsel = doesClientHavePreferredCounsel.value === true;
        const hasLawyer1 = clientsPreferredLawyer != null && clientsPreferredLawyer !== "";
        const hasLawyer2 = clientsPreferredLawyer2 != null && clientsPreferredLawyer2 !== "";
        const hasLawyer3 = clientsPreferredLawyer3 != null && clientsPreferredLawyer3 !== "";

        return {
            showDoesClientHavePreferredCounsel: true, // Always show
            showClientPreferredLawyer: hasPreferredCounsel && hasLawyer1,
            showClientPreferredLawyer2: hasPreferredCounsel && hasLawyer1 && hasLawyer2,
            showClientPreferredLawyer3: hasPreferredCounsel && hasLawyer1 && hasLawyer2 && hasLawyer3
        };
    };

    useEffect(() => {
        trackEventsInsights();
    }, [trackEvents]);

    // Helper function to update assignedBy state from backend response
    const updateAssignedByFromBackend = (assignedByValue) => {
        if (assignedByValue !== null && assignedByValue !== '') {
            try {
                const parsed = JSON.parse(assignedByValue);
                setAssignedBy(parsed);
                setOriginalAssignedBy(parsed);
            } catch (e) {
                setAssignedBy(assignedByValue);
                setOriginalAssignedBy(assignedByValue);
            }
        } else {
            setAssignedBy("");
            setOriginalAssignedBy("");
        }
    };

    const LoadInitialLookUpDataData = async (token) => {

        await FetchLookupData(token).then((data) => {
            if (data)
                setContactMethods(data.contactMethods);
        })
    }

    useEffect(() => {
        setIsLoading(true);

        const fetchInitialData = async (token) => {

            if (clientFileId && clientFileId > 0) {
                await GetClientFileById(clientFileId, token).then(data => {
                    setClientBasicInfo(data?.clientBasicInformation);
                    setClientContactInfo(data?.clientContactDetails);
                });
            };
            const metaData = await GetInteractionMetaData(token);
            var initialAssesmentOutcomes = [];
            if (metaData) {
                setFormStatuses(metaData.formStatuses);
                setFormStatus(metaData.formStatuses[0]);
                setDutyCounselTypes(metaData.dutyCounselTypes);
                setAdultOrYouthStatuses(metaData.adultOrYouthStatuses);
                setAssesmentOutcomes(metaData.assesmentOutcomes);
                setImprisonmentLikelihoods(metaData.imprisonmentLikelihoods);
                setAssignedToList(metaData.lawyers);
                initialAssesmentOutcomes = metaData.assesmentOutcomes;
                setStatuses(metaData.statuses);
                setStatusIdsReplacedByDisclosureStatus(metaData.statusIdsReplacedByDisclosureStatus ?? []);
                disclosure.takeChoices(metaData);
            }
            else {
                toast.error("An error occurred while loading data.", { position: "top-center", autoClose: 5000, theme: "colored" });
                appInsights.trackException({ error: new Error('An error occurred while loading data.'), severityLevel: SeverityLevel.Error });
            };

            // Parallelize independent API calls
            const [preferredCounsels, data] = await Promise.all([
                GetAllPreferredCounsels(token),
                interactionId && interactionId > 0 ? GetInteractionById(interactionId, token) : Promise.resolve(null)
            ]);

            if (preferredCounsels) {
                setPreferredCounselOptions(preferredCounsels);
            }

            if (interactionId && interactionId > 0 && data) {
                if (initialAssesmentOutcomes && data && data?.assesmentOutcomeId != 1) { 
                    var filteredAssesmentOutcomes = initialAssesmentOutcomes.filter(assesmentOutcome => assesmentOutcome.assesmentOutcomeId != 1 );
                    setAssesmentOutcomes(filteredAssesmentOutcomes);
                }
                
                // If not submitted, fetch preferred counsel fields from CRM (depends on data)
                let crmPreferredCounselData = null;
                if (data && data.isSubmitted !== true && data.interactionCrmId) {
                    crmPreferredCounselData = await GetPreferredCounselFromCrm(data.interactionCrmId, token);
                    if (!crmPreferredCounselData) {
                        toast.warn("Unable to load preferred counsel data from CRM. Displaying portal data instead.", { position: "top-center", autoClose: 8000, theme: "colored" });
                    }
                }
                
                setInitialInteraction(data, metaData, preferredCounsels, crmPreferredCounselData);
                setTrackEvents(JSON.stringify(data));
                appInsights.trackTrace({ message: JSON.stringify(data), severityLevel: SeverityLevel.Information });
            };
        }
        if (account) {
            instance.acquireTokenSilent(
                tokenRequest
            ).then((response) => {
                if (response) {
                    fetchInitialData(response.accessToken);
                }
            });
        }
        const fetchClientDetailNotes = async (token) => {
            await GetClientDetailNotes(interactionId, 3, 'false', token).then((data) => {
                setClientInteractionNotes(data);
            });
        }

        if (interactionId != null && interactionId > 0) {

            if (account) {
                instance.acquireTokenSilent(
                    tokenRequest
                ).then((response) => {
                    if (response) {
                        LoadInitialLookUpDataData(response.accessToken);
                        fetchClientDetailNotes(response.accessToken);
                    }
                });
            }
        }
        setIsLoading(false);
    }, [account, instance, isAuthenticated]);

    useEffect(() => {
        if ((isActive == true) && (isSubmitted == false)) {
            if (canSave()) {
                setIsReadOnly(false);
            } else {
                setIsReadOnly(true);
            }
        } else if ((currentAccount.idTokenClaims.roles[0].toString() === 'RosterLimitedAccess')) {
            setIsShowAttachments(false);
        } else if ((isActive == false) && (isSubmitted == false)) {
            setIsReadOnly(true);
        } else if ((currentAccount.idTokenClaims.roles[0].toString() === 'DutyCounselTriageLead')) {
            setIsReadOnly(false);
        } else if ((currentAccount.idTokenClaims.roles[0].toString() === 'RosterLimitedAccess')) {
            setIsReadOnly(false);
        } else {
            setIsReadOnly(true);
        }
    }, [isSubmitted, isActive]);

    useEffect(() => {
        if (!isFcUpdated) {
            backgroundSave();
        }
    });

    const clientBasicInfoComp = useRef();
    const clientContactInfoComp = useRef();

    const setInitialInteraction = (interaction, metadata, preferredCounselOptions = [], crmPreferredCounselData = null) => {
        setIsActive(interaction.isActive);
        setIsConflicted(interaction.isInteractionConflicted);
        setInteractionCrmId(interaction.interactionCrmId != null ? interaction.interactionCrmId : "");
        setClientFileCrmId(interaction.clientFileCrmId);
        if (interaction.formStatus) { setFormStatus(interaction.formStatus); }
        setAssignedTo((interaction.assignedTo !== null && interaction.assignedTo !== '') ? JSON.parse(interaction.assignedTo) : "");

        setOriginalAssignedTo((interaction.assignedTo !== null && interaction.assignedTo !== '')  ? JSON.parse(interaction.assignedTo) : "")
        setAssignedOn(interaction.assignedOn !== null ? interaction.assignedOn : "")
        
        // Parse assignedBy JSON from backend (backend returns {label: "John Doe", value: "user-id"})
        updateAssignedByFromBackend(interaction.assignedBy);

        //setDutyCounselType(interaction.dutyCounselType);
        setAdultOrYouth(interaction.isAdultOrYouth);
        disclosure.load(interaction, metadata);
        setDateOfFirstAttemptedContact(interaction.dateOfFirstAttemptedContact);
        setNextActionDate(interaction.nextActionDate);
        if (interaction.dateOfFirstAttemptedContact != null) setDisableDateOfFirstAttemptedContact(true);
        setFirstCourtDate(interaction.firstCourtDate);
        if (interaction.firstCourtDate != null) setDisableFirstCourtDate(true);
        setIsInCustody(interaction.isInCustody === true ? yesOrNoSelectionList[0] : (interaction.isInCustody === false ? yesOrNoSelectionList[1] : null));
        setFinancialStatus(interaction.financialStatus);
        setServiceDecisionNumber(interaction.serviceDecisionNumber);
        setAssesmentOutcome(interaction.assesmentOutcome != null ? interaction.assesmentOutcome : "");
        setNotes(interaction.notes);
        setAssesmentOutcomeDate(interaction.assesmentOutcomeDate != null ? interaction.assesmentOutcomeDate : "");
        setImprisonmentLikelihood(interaction.imprisonmentLikelihood);
        
        // If not submitted and CRM data is available, use CRM data for preferred counsel fields
        if (interaction.isSubmitted !== true && crmPreferredCounselData) {
            setDoesClientHavePreferredCounsel(crmPreferredCounselData.doesClientHavePreferredCounsel === true ? yesOrNoSelectionList[0] : yesOrNoSelectionList[1]);
            
            // Parse JSON strings from CRM to objects
            try {
                setClientsPreferredLawyer(crmPreferredCounselData.clientsPreferredLawyer != null && crmPreferredCounselData.clientsPreferredLawyer !== "" 
                    ? JSON.parse(crmPreferredCounselData.clientsPreferredLawyer) : "");
                setClientsPreferredLawyer2(crmPreferredCounselData.clientsPreferredLawyer2 != null && crmPreferredCounselData.clientsPreferredLawyer2 !== "" 
                    ? JSON.parse(crmPreferredCounselData.clientsPreferredLawyer2) : "");
                setClientsPreferredLawyer3(crmPreferredCounselData.clientsPreferredLawyer3 != null && crmPreferredCounselData.clientsPreferredLawyer3 !== "" 
                    ? JSON.parse(crmPreferredCounselData.clientsPreferredLawyer3) : "");
            } catch (e) {
                // Fallback if parsing fails
                console.error("Error parsing preferred counsel from CRM:", e);
                setClientsPreferredLawyer("");
                setClientsPreferredLawyer2("");
                setClientsPreferredLawyer3("");
            }
        } else {
            // Use interaction data for submitted interactions or when CRM data is not available
            setDoesClientHavePreferredCounsel(interaction.doesClientHavePreferredCounsel === true ? yesOrNoSelectionList[0] : yesOrNoSelectionList[1]);
            
            // Parse if stored as JSON string in database
            try {
                setClientsPreferredLawyer(interaction.clientsPreferredLawyer != null && interaction.clientsPreferredLawyer !== "" 
                    ? (typeof interaction.clientsPreferredLawyer === 'string' ? JSON.parse(interaction.clientsPreferredLawyer) : interaction.clientsPreferredLawyer) : "");
                setClientsPreferredLawyer2(interaction.clientsPreferredLawyer2 != null && interaction.clientsPreferredLawyer2 !== "" 
                    ? (typeof interaction.clientsPreferredLawyer2 === 'string' ? JSON.parse(interaction.clientsPreferredLawyer2) : interaction.clientsPreferredLawyer2) : "");
                setClientsPreferredLawyer3(interaction.clientsPreferredLawyer3 != null && interaction.clientsPreferredLawyer3 !== "" 
                    ? (typeof interaction.clientsPreferredLawyer3 === 'string' ? JSON.parse(interaction.clientsPreferredLawyer3) : interaction.clientsPreferredLawyer3) : "");
            } catch (e) {
                // Fallback for legacy data or parsing errors
                console.error("Error parsing preferred counsel from interaction:", e);
                setClientsPreferredLawyer(interaction.clientsPreferredLawyer || "");
                setClientsPreferredLawyer2(interaction.clientsPreferredLawyer2 || "");
                setClientsPreferredLawyer3(interaction.clientsPreferredLawyer3 || "");
            }
        }
        
        // Find matching preferred counsel option from the list
        if (interaction.newPreferredCounsel != null && interaction.newPreferredCounsel !== '' && preferredCounselOptions.length > 0) {
            try {
                // Parse JSON string to get the value (id) for matching
                const parsed = typeof interaction.newPreferredCounsel === 'string' 
                    ? JSON.parse(interaction.newPreferredCounsel) 
                    : interaction.newPreferredCounsel;
                const matchingOption = preferredCounselOptions.find(option => option.id === parsed.value);
                setNewPreferredCounsel(matchingOption ? matchingOption : "");
            } catch (e) {
                // Fallback: try matching directly by id (legacy data)
                const matchingOption = preferredCounselOptions.find(option => option.id === interaction.newPreferredCounsel);
                setNewPreferredCounsel(matchingOption ? matchingOption : "");
            }
        } else {
            setNewPreferredCounsel("");
        }
        setIsSubmitted(interaction.isSubmitted != null ? interaction.isSubmitted : false);
        setDockets(interaction.dockets.sort((a, b) => a.docketNumber.localeCompare(b.docketNumber)));
        setCanAssignedTo((currentAccount.idTokenClaims.roles[0].toString() === 'DutyCounselTriageLead') || (currentAccount.idTokenClaims.roles[0].toString() === 'LegalServicesManager') ? false : true);
        setIsInitiallyDisabled(true);
        latestCourtDate(interaction.dockets, interaction.firstCourtDate);
        setCreatedOn(interaction.createdOn);
        setCreatedBy(interaction.createdBy);
        if (interaction.statusDetails) { 
            setStatus(interaction.statusDetails); 

            var isAlive = metadata.statuses.find(
                (item) => item?.label === interaction.statusDetails.label
            );
            
            if(!isAlive) {
                setIsStatusExpired(true);
            }
            else {
                setIsStatusExpired(false);
            }
        }
    };

    const handleToggle = (text) => () => {
        setScreenSideBarKey(text);
        let listItemKey = `${screenSideBarList?.indexOf(text) + 1}`;
        const element = document.getElementById('scrollByClickedItem' + listItemKey.toString());
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const validateInteractionDetails = ({ silent = false } = {}) => {
        var status = true;
        if (!formStatus || formStatus === "") { setFormStatusError(true); status = false; }
        // if (!dutyCounselType || dutyCounselType === "") { setDutyCounselTypeError(true); status = false; }
        // if (!adultOrYouth || adultOrYouth === "") { setAdultOrYouthError(true); status = false; }
        if (!disclosure.validate({ silent })) { status = false; }
        //if (!firstCourtDate || firstCourtDate === "") { setFirstCourtDateError(true); status = false; }
        // if (!isInCustody || isInCustody === "") { setIsInCustodyError(true); status = false; }
        // if (!serviceDecisionNumber || serviceDecisionNumber === "") { setServiceDecisionNumberError(true); status = false; }
        if ((assesmentOutcome && assesmentOutcome !== "") && (!imprisonmentLikelihood || imprisonmentLikelihood === "")) { setImprisonmentLikelihoodError(true); status = false; }
        if ((assesmentOutcome && assesmentOutcome !== "") && (!assignedTo || assignedTo === "")) { setAssignedToError(true); status = false; }
        if (isNextActionDateInvalid) { status = false; }
        return status;
    };



    const canSave = () => {
        var result = false;

        if (null != interactionId && interactionId > 0) {
            result = canUpdate("interaction", (null != assignedTo) ? assignedTo.value : null);
        }

        return result;
    };

    const canCreateAgencyRequest = () => { return ((null != interactionId) && (interactionId > 0) && canCreate("agency-request", null)); }

    const onSaveClicked = async (option) => {
        if (clientFileId && clientFileId > 0) {
            const isValidData = validateInteractionDetails();
            if (isValidData) {
                disclosure.refreshAutomaticDates();
                //setSaveClicked(true);
                var interactionDetails = createInteractionObject();
                setTrackEvents(JSON.stringify(interactionDetails));
                appInsights.trackTrace({ message: JSON.stringify(interactionDetails), severityLevel: SeverityLevel.Information });
                if (account) {
                    instance.acquireTokenSilent(
                        tokenRequest
                    ).then((response) => {
                        if (response) {
                            UpdateInteraction(interactionDetails, response.accessToken, false).then((success) => {
                                if (success) {
                                    // What the save stored: a date the page filled in is a saved date from now on
                                    disclosure.settleAutomaticDates();
                                    // Fetch the updated interaction to get backend-populated assignedBy
                                    GetInteractionById(interactionId, response.accessToken).then((updatedInteraction) => {
                                        if (updatedInteraction) {
                                            // Update state with backend response
                                            setOriginalAssignedTo((updatedInteraction.assignedTo !== null && updatedInteraction.assignedTo !== '') ? JSON.parse(updatedInteraction.assignedTo) : "")
                                            setAssignedOn(updatedInteraction.assignedOn !== null ? updatedInteraction.assignedOn : "")
                                            
                                            // Parse assignedBy JSON from backend
                                            updateAssignedByFromBackend(updatedInteraction.assignedBy);
                                        }
                                        
                                        if (option === 1) {
                                            navigateToPage();
                                        }
                                    }).catch(() => {
                                        // Re-fetch failed but save succeeded -- still navigate if requested
                                        if (option === 1) {
                                            navigateToPage();
                                        }
                                    });
                                } else {
                                    toast.error("Failed to save interaction.", { position: "top-center", autoClose: 5000, theme: "colored" });
                                }
                            });
                        }
                    });
                }
            }
        }
        else {
            toast.error("Cannot create an interaction. Interaction needs to have an associated client file.", { position: "top-center", autoClose: 5000, theme: "colored" });
        }
    };



    const createInteractionObject = () => {
        const now = new Date();
        let newAssignedOn = assignedOn;
        
        if (!assignedTo || assignedTo === '') {
            newAssignedOn = null;
        }
        else if (assignedTo) {
            // Check if Assigned To matches the original value
            const isOriginalAssignment = originalAssignedTo && originalAssignedTo.value === assignedTo.value;
            
            if (!isOriginalAssignment) {
                // New or changed assignment
                newAssignedOn = now;
                // assignedBy will be set server-side from JWT claims
            }
        }

        const interaction = {
            "createdBy": createdBy && createdBy !== '' ? createdBy : "System",
            "createdOn": createdOn && createdOn !== '' ? new Date(createdOn) : now,
            "modifiedBy": "System",
            "modifiedOn": now,
            "interactionId": interactionId,
            "isActive": isActive,
            "clientFileId": clientFileId,
            "formStatusId": formStatus ? formStatus?.formStatusId : null,
            "assignedTo": (assignedTo &&  assignedTo !== '') ? JSON.stringify(assignedTo) : null,
            "assignedOn": newAssignedOn ? new Date(newAssignedOn) : null,
            // assignedBy is NOT sent - backend sets it from JWT claims
            "interactionCrmId": interactionCrmId ? interactionCrmId : null,
            //"dutyCounselTypeId": dutyCounselType ? dutyCounselType?.dutyCounselTypeId : null,
            "isAdultOrYouthId": adultOrYouth ? adultOrYouth?.adultOrYouthStatusId : null,
            ...disclosure.toSave(),
            "dateOfFirstAttemptedContact": dateOfFirstAttemptedContact ? new Date(dateOfFirstAttemptedContact) : null,
            "nextActionDate": nextActionDate ? new Date(nextActionDate) : null,
            "firstCourtDate": firstCourtDate !== "" ? new Date(firstCourtDate) : null,
            "isInCustody": isInCustody ? isInCustody?.value : null,
            "serviceDecisionNumber": serviceDecisionNumber ? serviceDecisionNumber : null,
            "assesmentOutcomeId": assesmentOutcome ? assesmentOutcome?.assesmentOutcomeId : null,
            "assesmentOutcomeDate": assesmentOutcomeDate ? new Date(assesmentOutcomeDate) : null,
            "imprisonmentLikelihoodId": imprisonmentLikelihood ? imprisonmentLikelihood?.imprisonmentLikelihoodId : null,
            "isSubmitted": isSubmitted,
            "isInteractionConflicted": isConflicted,
            "clientFileCrmId": clientFileCrmId,
            "status": status && status.id > 0 ? status?.id : null,
            "newPreferredCounsel": newPreferredCounsel && typeof newPreferredCounsel === 'object' && newPreferredCounsel.id && newPreferredCounsel.label
                ? JSON.stringify({ label: newPreferredCounsel.label, value: newPreferredCounsel.id }) : null,
            "doesClientHavePreferredCounsel": doesClientHavePreferredCounsel?.value === true ? true : (doesClientHavePreferredCounsel?.value === false ? false : null),
            // Stringify preferred counsel objects for database storage
            "clientsPreferredLawyer": clientsPreferredLawyer && clientsPreferredLawyer !== "" 
                ? (typeof clientsPreferredLawyer === 'object' ? JSON.stringify(clientsPreferredLawyer) : clientsPreferredLawyer) : null,
            "clientsPreferredLawyer2": clientsPreferredLawyer2 && clientsPreferredLawyer2 !== "" 
                ? (typeof clientsPreferredLawyer2 === 'object' ? JSON.stringify(clientsPreferredLawyer2) : clientsPreferredLawyer2) : null,
            "clientsPreferredLawyer3": clientsPreferredLawyer3 && clientsPreferredLawyer3 !== "" 
                ? (typeof clientsPreferredLawyer3 === 'object' ? JSON.stringify(clientsPreferredLawyer3) : clientsPreferredLawyer3) : null,
        }

        if ((interactionId != null) && (interactionId > 0)) {
            interaction.interactionId = interactionId;
        }
        return interaction;
    }



    const handleSelectChanged = (event, menuItems, setSelectedMenuItem, setSelectedMenuItemError) => {
        const selectedMenuItem = menuItems.find(
            (item) => item?.label === event.target.value
        );
        setSelectedMenuItem(selectedMenuItem);
        if (selectedMenuItem) { setSelectedMenuItemError(false); }
    };

    const onFormStatusChanged = (event) => {
        handleSelectChanged(event, formStatuses, setFormStatus);
    };

    const onAssignedToChanged = (event) => {
        // handleSelectChanged(event,assignedToList,setAssignedTo );
        const selectedMenuItem = assignedToList.find(
            (item) => item?.label === event.target.value
        );
        setAssignedTo(selectedMenuItem);
        if (selectedMenuItem && selectedMenuItem !== "") setAssignedToError(false);
        
        // When user changes Assigned To, show current user as Assigned By (for display only)
        // Backend will set the actual value from JWT claims when saved
        if (selectedMenuItem && selectedMenuItem !== "") {
            // Check if this is a change from the original assignment
            const isChangingAssignment = !originalAssignedTo || 
                                        (originalAssignedTo.value !== selectedMenuItem.value);
            
            if (isChangingAssignment && currentAccount) {
                // Display current user's name as preview
                const currentUserDisplay = {
                    label: currentAccount.name || currentAccount.username || "",
                    value: currentAccount.localAccountId || ""
                };
                setAssignedBy(currentUserDisplay);
            } else {
                // Reverted to original Assigned To -- restore original Assigned By
                setAssignedBy(originalAssignedBy);
            }
        } else {
            // Clear assignedBy if assignedTo is cleared
            setAssignedBy("");
        }
        
        // if (assesmentOutcome && assesmentOutcome !== "" && assesmentOutcome.assesmentOutcomeId !== 8) {
        //     setFormStatus(formStatuses[2])
        // } else 
        if (selectedMenuItem && selectedMenuItem !== "" && formStatus?.formStatusId !== 3) {
            setFormStatus(formStatuses[1])
        } else if (formStatus?.formStatusId !== 3) {
            setFormStatus(formStatuses[0])
        }
    };

    // const onDutyCounselTypeChanged = (event) => {
    //     handleSelectChanged(event,dutyCounselTypes,setDutyCounselType );
    // }; 

    // The held Status stays shown when it can no longer be chosen (expired, or replaced on this layout), with why
    const isReplacedByDisclosureStatus = (candidate) => disclosure.showDisclosureInformation === true && statusIdsReplacedByDisclosureStatus.includes(candidate?.id);
    const offeredStatuses = statuses.filter((candidate) => !isReplacedByDisclosureStatus(candidate));
    const heldStatusHint = isStatusExpired ? STATUS_EXPIRED_HINT : (isReplacedByDisclosureStatus(status) ? STATUS_REPLACED_HINT : null);

    const onDateOfFirstAttemptedContactChanged = (date) => {
        setDateOfFirstAttemptedContact(date);
        if (date != null) {
            if ((new Date(date)).toString() === "Invalid Date") { //|| new Date(date) > new Date()
                setIsdateOfFirstAttemptedContactInvalid(true);
            } else {
                setDateOfFirstAttemptedContact(Date.parse(date));
                setIsdateOfFirstAttemptedContactInvalid(false);
            };
        } else {
            setDateOfFirstAttemptedContact(date);
            setIsdateOfFirstAttemptedContactInvalid(false);
        }
    };

    const onNextActionDateChanged = (date) => {
        setNextActionDate(date);
        if (date != null) {
            if ((new Date(date)).toString() === "Invalid Date") { //|| new Date(date) > new Date()
                setIsNextActionDateInvalid(true);
            } else {
                setNextActionDate(Date.parse(date));
                setIsNextActionDateInvalid(false);
            };
        } else {
            setNextActionDate(date);
            setIsNextActionDateInvalid(false);
        }
    };

    const onFirstCourtDateChanged = (date) => {
        setFirstCourtDate(date);
        if (date != null) {
            setFirstCourtDateError(false);
            if ((new Date(date)).toString() === "Invalid Date") { // || new Date(date) > new Date()
                setIsFirstCourtDateInvalid(true);
            } else {
                setFirstCourtDate(Date.parse(date));
                setFirstCourtDateError(false);
                setIsFirstCourtDateInvalid(false);
            };
        } else {
            setFirstCourtDate(date);
            setFirstCourtDateError(true);
            setIsFirstCourtDateInvalid(false);
        }
    };

    const onInCustodyChanged = (event) => {
        handleSelectChanged(event, yesOrNoSelectionList, setIsInCustody);
    };

    const onServiceDecisionNumberChanged = (event) => {
        setServiceDecisionNumber(event.target.value);
    };

    const onViewDetailsClicked = () => {

        var otherParams = "";
        if (backPage == Constants.TOPASSIGNEDFILES || backPage == Constants.TOPMYFILES || backPage == Constants.TOPFILESTOASSIGN ||
            backPage == Constants.ASSIGNEDFILES || backPage == Constants.MYFILES || backPage == Constants.FILESTOASSIGN) {
                otherParams =  `backto=${backPage}&page=interaction&interactionId=${interactionId}`;
        }
        else {
            otherParams = `page=interaction&interactionId=${interactionId}`;
        }

        navigate(`${prepareNavigationParameters(Constants.SERVICEDECISION, new Array(clientFileId, interactionCrmId), null, otherParams)}`);
    };

    const onNotesChanged = (event) => {
        setNotes(event.target.value);
    };

    const onAssesmentOutcomeChanged = (event) => {
        const selectedMenuItem = assesmentOutcomes.find(
            (item) => item?.label === event.target.value
        );
        setAssesmentOutcome(selectedMenuItem);
        if (selectedMenuItem && selectedMenuItem !== "" && selectedMenuItem.assesmentOutcomeId !== 8) {
            if (assesmentOutcomeDate === "") setAssesmentOutcomeDate(new Date());          
        } else if (assignedTo && assignedTo !== "") {
            setFormStatus(formStatuses[1])
        }
        else {
            setFormStatus(formStatuses[0])
        }
    };

    const onLikelihoodOfImprisonmentChanged = (event) => {
        handleSelectChanged(event, imprisonmentLikelihoods, setImprisonmentLikelihood, setImprisonmentLikelihoodError);
    };

    const onStatusChanged = (event) => {
        handleSelectChanged(event, statuses, setStatus, setStatusError);

        var isAlive = statuses.find(
            (item) => item?.label === event.target.value
        );
        if(!isAlive) {
            setIsStatusExpired(true);
        }
        else {
            setIsStatusExpired(false);
        }
    };

    const onCancelClicked = () => {
        navigateToPage();
    };

    const onCreateARClicked = async (event) => {
        if (canCreate("agency-request", null)) {
            if (interactionId != null && interactionId > 0) {
                var otherParams = "";
                if (backPage == Constants.TOPASSIGNEDFILES || backPage == Constants.TOPMYFILES || backPage == Constants.TOPFILESTOASSIGN ||
                    backPage == Constants.ASSIGNEDFILES || backPage == Constants.MYFILES || backPage == Constants.FILESTOASSIGN) {
                    otherParams = `backto=${backPage}&page=interaction&interactionId=${interactionId}`;
                }
                else {
                    otherParams = `page=interaction&interactionId=${interactionId}`;
                }

                navigate(`${prepareNavigationParameters(Constants.AGENCYREQUEST, new Array(null, clientFileId), null, otherParams)}`);
            } else {
                navigate(`${prepareNavigationParameters(Constants.AGENCYREQUEST, new Array(null, clientFileId), null, "page=interaction&id=0")}`);
            }
        }
        else {
            toast.error("You don't have permission to add Agency Requests.", { position: "top-center", autoClose: 5000, theme: "colored" });
        }
    }

    function navigateToPage() {
        if (backPage == Constants.CLIENTFILEVIEWDETAILS)
            navigate(`${prepareNavigationParameters(null, null, null, "page=" + Constants.CLIENTFILEDASHBOARD)}`);
        else
            navigate(`${prepareNavigationParameters(null, null, null)}`);

    }

    const isSubmitReady = () => {
        return (canSave() && (formStatus !== null && formStatus !== "" && (formStatus.formStatusId === 2 || formStatus.formStatusId === 3) && assignedTo !== "" && assesmentOutcome !== "" && !isSubmitted))
    }

    const canDeleteInteraction = () => {
        return ((null != searchParams.get(Constants.IDQUERYSTRINGPARAM)) && (Number(searchParams.get(Constants.IDQUERYSTRINGPARAM)) > 0) && canDelete('interaction', null));
    };

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const onDeleteClickOpen = () => {
        setOpenDeleteDialog(true);
    };
    const onDeleteClickClose = () => {
        setOpenDeleteDialog(false);
    };

    const onDeleteClicked = (event) => {
        setTrackEvents("Deleting Interaction By Id : " + searchParams.get(Constants.IDQUERYSTRINGPARAM));
        appInsights.trackTrace({ message: "Deleting Interaction By Id : " + searchParams.get(Constants.IDQUERYSTRINGPARAM), severityLevel: SeverityLevel.Information });
        if (account) {
            instance.acquireTokenSilent(
                tokenRequest
            ).then((response) => {
                if (response) {
                    DeleteInteraction(Number(searchParams.get(Constants.IDQUERYSTRINGPARAM)), response.accessToken).then(() => {
                        navigateToPage();
                    });
                }
            });
        }
    }

    const [openConfirmMarkAsConflictedDialog, setOpenConfirmMarkAsConflictedDialog] = useState(false);

    const onConfirmMarkAsConflictedClickOpen = () => {
        setOpenConfirmMarkAsConflictedDialog(true);
    };

    const onConfirmMarkAsConflictedClickClose = () => {
        setOpenConfirmMarkAsConflictedDialog(false);
    };

    const onMarkAsConflictedClicked = async (event) => {
        setTrackEvents("Marking Interaction as conflicted : " + searchParams.get(Constants.IDQUERYSTRINGPARAM));
        appInsights.trackTrace({ message: "Marking Interaction as conflicted : " + searchParams.get(Constants.IDQUERYSTRINGPARAM), severityLevel: SeverityLevel.Information });
        if (account) {
            instance.acquireTokenSilent(
                tokenRequest
            ).then((response) => {
                if (response) {
                    MarkInteractionForReview(Number(searchParams.get(Constants.IDQUERYSTRINGPARAM)), response.accessToken).then(() => {
                        window.location.reload();
                    });
                }
            });
        }
    }

    function Save() {

        onSaveClicked(0);
    }

    function SaveAndClose() {

        onSaveClicked(1);
    }
    const onSubmitClicked = async (event) => {
        if (clientFileId && clientFileId > 0) {
            const isValidData = validateInteractionDetails();
            if (isValidData) {
                disclosure.refreshAutomaticDates();
                setIsSubmitted(true);
                var interactionDetails = createInteractionObject();
                interactionDetails.isSubmitted = true;
                interactionDetails.formStatusId = 3;
                setTrackEvents(JSON.stringify(interactionDetails));
                appInsights.trackTrace({ message: JSON.stringify(interactionDetails), severityLevel: SeverityLevel.Information });
                if (account) {
                    instance.acquireTokenSilent(
                        tokenRequest
                    ).then((response) => {
                        if (response) {
                            SubmitInteraction(interactionDetails, response.accessToken).then((success) => {
                                if (success) {
                                    // What the save stored: a date the page filled in is a saved date from now on
                                    disclosure.settleAutomaticDates();
                                    // Fetch the updated interaction to get backend-populated assignedBy
                                    GetInteractionById(interactionId, response.accessToken).then((updatedInteraction) => {
                                        if (updatedInteraction) {
                                            // Update state with backend response
                                            setOriginalAssignedTo((updatedInteraction.assignedTo !== null && updatedInteraction.assignedTo !== '') ? JSON.parse(updatedInteraction.assignedTo) : "")
                                            setAssignedOn(updatedInteraction.assignedOn !== null ? updatedInteraction.assignedOn : "")
                                            
                                            // Parse assignedBy JSON from backend
                                            updateAssignedByFromBackend(updatedInteraction.assignedBy);
                                        }
                                        //navigate(NAVIGATEURL + clientFileId);
                                    }).catch(() => {
                                        // Re-fetch failed but submit succeeded -- state may be stale but operation completed
                                    });
                                } else {
                                    toast.error("Failed to submit interaction.", { position: "top-center", autoClose: 5000, theme: "colored" });
                                }
                            });
                        }
                    });
                }
            }
        }
        else {
            toast.error("Cannot submit interaction. Interaction needs to have an associated client file.", { position: "top-center", autoClose: 5000, theme: "colored" });
        }
    };

    const handleModalOpen = () => { setOpenFEGModal(true); };
    const handleModalClose = () => { setOpenFEGModal(false); };

    const filterFutureDockets = (docket) => {
        var date1 = new Date(docket.upcomingCourtDate);
        var now = new Date();

        return (date1 > now);
    }

    const compareDocketDetails = (a, b) => {
        if (Date.parse(a.upcomingCourtDate) < Date.parse(b.upcomingCourtDate)) {
            return -1;
        }
        if (Date.parse(a.upcomingCourtDate) > Date.parse(b.upcomingCourtDate)) {
            return 1;
        }
        return 0;
    }

    const latestCourtDate = (lstDockets, fcdate) => {
        if (!fcdate) {
            if (lstDockets && lstDockets.length > 0) {
                var lstDocketswithUpcomingCourtDates = [];
                lstDockets.forEach((docket) => {
                    if (null != docket.upcomingCourtDate) {
                        lstDocketswithUpcomingCourtDates.push(docket);
                    }
                });
                var sortedDocets = lstDocketswithUpcomingCourtDates.sort(compareDocketDetails);
                var upcomingCourtDate = sortedDocets.length > 0 ? sortedDocets[0].upcomingCourtDate : '';
                setFirstCourtDate(upcomingCourtDate);

            }
            else {
                setFirstCourtDate('');
            }

        }
    }

    const backgroundSave = async () => {

        if (clientFileId && clientFileId > 0 && firstCourtDate !== '') {
            // The disclosure section checks silently: its messages wait for the user's Save
            const isValidData = validateInteractionDetails({ silent: true });
            setFormStatusError(false);
            disclosure.clearQuestionMessages();
            setImprisonmentLikelihoodError(false);
            setAssignedToError(false);
            // A Disclosure Information section with unsaved changes is left to the user's Save (stories 11032/11033):
            // nothing in it is stored silently
            if (isValidData && !disclosure.changedSinceLoad) {
                //setSaveClicked(true);
                setIsFcUpdated(true);
                var interactionDetails = createInteractionObject();
                //interactionDetails.firstCourtDate = firstCourtDate;
                if (account) {
                    instance.acquireTokenSilent(
                        tokenRequest
                    ).then((response) => {
                        if (response) {
                            UpdateInteraction(interactionDetails, response.accessToken, true).then((success) => {
                                setIsFcUpdated(true);
                                if (success) {
                                    // What the save stored: as after the user's own save
                                    disclosure.settleAutomaticDates();
                                }
                            });
                        }
                    });
                }
            }
        }
        else {
            //toast.error("Cannot create an interaction. Interaction needs to have an associated client file.", { position: "top-center", autoClose: 5000, theme: "colored" });
        }
    };


    if (isLoading) {
        return (
            <Backdrop />
        );
    } else {

        if (canRead("interaction", null)) {
            // Calculate preferred counsel visibility once before rendering
            const counselVisibility = getPreferredCounselVisibility();

            const isLocked = isConflicted || isReadOnly;
            // Until the API has said which layout the interaction uses, the disclosure questions are drawn nowhere
            const usesDisclosureSection = disclosure.showDisclosureInformation === true;
            const usesLegacyLayout = disclosure.showDisclosureInformation === false;

            return (
                <Grid container style={{ padding: "10px 20px 0px 20px", margin: "80px 0px 60px 0px" }}>
                    <SubHeader
                        title="Client Interactions"
                        menuItemOneText="Delete Interaction"
                        onMenuItemOneClicked={onDeleteClickOpen}
                        isMenuItemOneVisible={canDeleteInteraction()}
                        isMenuItemOneDisabled={false}
                        menuItemTwoText="Mark for Review"
                        onMenuItemTwoClicked={onConfirmMarkAsConflictedClickOpen}
                        isMenuItemTwoVisible={((canUpdate("interaction", null)) && (Number(searchParams.get(Constants.IDQUERYSTRINGPARAM)) && Number(searchParams.get(Constants.IDQUERYSTRINGPARAM)) > 0) && (!isConflicted))}
                        menuItemTwoType="Warning"
                        isMenuItemTwoDisabled={false}

                        navItemOneText="Save"
                        onNavItemOneClicked={Save}
                        isNavItemOneVisible={true}
                        isNavItemOneDisabled={canSave() ? (saveClicked) : true}

                        navItemTwoText="Save & Close"
                        onNavItemTwoClicked={SaveAndClose}
                        isNavItemTwoVisible={true}
                        isNavItemTwoDisabled={canSave() ? (saveClicked) : true}

                        navItemThreeText="Submit"
                        onNavItemThreeClicked={onSubmitClicked}
                        isNavItemThreeVisible={isSubmitReady()}
                        isNavItemThreeDisabled={isReadOnly}

                        navItemFourText="New Duty Counsel Request"
                        onNavItemFourClicked={onCreateARClicked}
                        isNavItemFourVisible={canCreateAgencyRequest()}
                        isNavItemFourDisabled={false}

                        navItemFiveText="Cancel"
                        onNavItemFiveClicked={onCancelClicked}
                        isNavItemFiveVisible={true}
                        isNavItemFiveDisabled={false}

                    />
                    <StyledDialog title="Mark for Review" open={openConfirmMarkAsConflictedDialog} onClose={onConfirmMarkAsConflictedClickClose}
                        message={"Do you really want to mark the Interaction :" + Number(searchParams.get(Constants.IDQUERYSTRINGPARAM)) + " for review?"}
                        onConfirmed={onMarkAsConflictedClicked} confirmationText="Mark for Review" />
                    <StyledDialog title="Delete Interaction"
                        open={openDeleteDialog}
                        onClose={onDeleteClickClose}
                        message={"Do you really want to delete the Interaction :" + Number(searchParams.get(Constants.IDQUERYSTRINGPARAM)) + " ? This process cannot be undone."}
                        onConfirmed={onDeleteClicked}
                        confirmationText="Delete" />
                    {/* <ScreenSideBar screenSideBarList={screenSideBarList} handleToggle={handleToggle} screenSideBarKey={screenSideBarKey} /> */}
                    {!isActive && !isSubmitted && (<>
                        <Badge bg="danger" style={{ marginBottom: "10px" }}>** Inactive **</Badge>
                    </>)}
                    {isSubmitted && (<>
                        <Badge bg="success" style={{ marginBottom: "10px" }}>** Submitted **</Badge>
                    </>)}
                    {isConflicted && (<>
                        <Badge bg="danger" style={{ marginBottom: "10px" }}>** Needs Review **</Badge>
                    </>)}
                    <Grid item xs={12} md={12} >
                        <Grid container style={{ padding: "10px 20px 0px 20px", border: "1px solid #7F8284", borderRadius: "8px", backgroundColor: "#ececec" }}>
                            <Grid item xs={12} md={12} style={{
                                textAlign: "left", font: "normal normal normal 17px/22px Franklin Gothic Medium",
                                letterSpacing: "0px", color: " #000000", opacity: "1", marginBottom: "10px"
                            }}>Client Information
                            </Grid>
                            {/* <Grid item xs={6} md={6} style={{ textAlign: "right", paddingRight: "10px" }}>
                                <TextButton label="Financial Eligibility Guidelines" size="small" handleOnClick={handleModalOpen} />
                            </Grid> */}
                            <StyledModal open={openFEGModal} title="Financial Eligibility" handleOnClose={handleModalClose} />
                            <Grid item xs={12} sm={6} md={4} lg={4} style={{ margin: "10px 0px 10px 0px", }}>
                                <TextField label="First Name" placeholder="First Name" required={true} disabled={true} value={clientBasicInfo?.firstName} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} style={{ margin: "10px 0px 10px 0px",  }}>
                                <TextField label="Middle Name" placeholder="Middle Name" disabled={true} value={clientBasicInfo?.middleName} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} style={{ margin: "10px 0px 10px 0px",  }}>
                                <TextField label="Last Name" placeholder="Last Name" required={true} disabled={true} value={clientBasicInfo?.lastName} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} style={{ margin: "10px 0px 10px 0px", }}>
                                <CustomDatePicker label="Date of Birth" placeholder="dd-Mmm-yyyy" required={true} disabled={true} value={clientBasicInfo?.dateOfBirth} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} style={{ margin: "10px 0px 10px 0px",  }}>
                                <TextField label="Email" placeholder="Email" required={false} disabled value={clientContactInfo?.email} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} style={{ margin: "10px 0px 10px 0px",  }}>
                                <TextField label="Phone Number" placeholder="Phone Number" required={false} disabled value={clientContactInfo?.phoneNumber} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} style={{ margin: "10px 0px 10px 0px", }}>
                                <TextField label="Mobile Number" placeholder="Mobile Number" required={false} disabled value={clientContactInfo?.mobileNumber} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4} lg={4} style={{ margin: "10px 0px 10px 0px",  }}>
                                <SelectorTextField label="Preferred Method of Contact" placeholder="Method of Contact" select disabled
                                    value={(null == clientContactInfo?.preferredMethodOfContactId) ? "" : clientContactInfo?.preferredMethodOfContactId}>
                                    {contactMethods?.map((contactMethod) => (
                                        <MenuItem key={contactMethod.contactMethodId} value={contactMethod.contactMethodId}>
                                            {contactMethod.label}
                                        </MenuItem>))}
                                </SelectorTextField>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={12} style={{ margin: "10px 0px 10px 0px", backgroundColor: isConflicted ? "#ececec" : null }}>
                            <NoteTable title="Interaction Notes" notes={clientInteractionNotes} clientFileId={clientFileId} relatedId={interactionId} noteTypeId={3} queryParams={"clientFileId=" + clientFileId.toString()} isDisabled={(isConflicted) ? true : false} pageId={backPage} />
                        </Grid>
                        <Box sx={sectionContainerSx(isLocked)} data-testid="lawyer-information-section">
                            <Box sx={SECTION_TITLE_SX}>Lawyer Information</Box>

                            {/* ═══ 4-Column Sidebar Layout ═══
                                 xs (<600px): 1 column stacked
                                 sm (600-899px): 2 columns wrapped (2x2 grid) — iPad portrait
                                 md (900px+): 4 columns side-by-side — iPad landscape & desktop
                            */}
                            <Box sx={SECTION_BODY_SX}>

                                {/* ═══ Column 1: Form Status, Assigned By, Assigned To, Permission to order disclosure? (legacy layout only), Date of First Attempted Contact, Assessment Outcome ═══ */}
                                <Box sx={COLUMN_SX}>
                                    <Box sx={FIELD_SX}>
                                        <SelectorTextField label="Form Status" placeholder="Form Status" required={true} style={{ backgroundColor: COLORS.DISABLED_BACKGROUND }}
                                            select
                                            error={formStatusError ? true : null}
                                            value={formStatus ? formStatus?.label : ""}
                                            disabled={true}
                                            //handleChange={onFormStatusChanged}
                                            helperText={formStatusError ? "Form Status is required." : null}>
                                            {formStatuses.map((status) => (
                                                <MenuItem key={status.formStatusId} value={status.label}>
                                                    {status.label}
                                                </MenuItem>))}
                                        </SelectorTextField>
                                    </Box>
                                    <Box sx={FIELD_SX}>
                                        <TextField label="Assigned By" placeholder="Assigned By" 
                                            style={{ backgroundColor: COLORS.DISABLED_BACKGROUND }}
                                            disabled={true}
                                            value={assignedBy ? (assignedBy.label || assignedBy) : ""}
                                        />
                                    </Box>
                                    <Box sx={FIELD_SX}>
                                        <SelectorTextField label="Assigned To" placeholder="Assigned to Lawyer" style={{ backgroundColor: canAssignedTo ? COLORS.DISABLED_BACKGROUND : null }}
                                            select
                                            required={(assesmentOutcome && assesmentOutcome !== "") ? true : false}
                                            disabled={isConflicted || canAssignedTo || isReadOnly ? true : null}
                                            error={assignedToError ? true : null}
                                            value={assignedTo ? assignedTo?.label : ""}
                                            handleChange={onAssignedToChanged}
                                            helperText={assignedToError ? "Assigned To is required." : null}
                                            SelectProps={{ MenuProps: { style: { maxHeight: 250, }, }, }}>
                                            {assignedToList.map((lawyer) => (
                                                <MenuItem key={lawyer.value} value={lawyer.label}>
                                                    {lawyer.label}
                                                </MenuItem>))}
                                        </SelectorTextField>
                                    </Box>
                                    {usesLegacyLayout && <YesOrNoQuestion question={disclosure.permission} disabled={isLocked} />}
                                    <Box sx={FIELD_SX}>
                                        <CustomDatePicker label="Date of First Attempted Contact" placeholder="Date of First Attempted Contact"
                                            style={{ width: "100%", backgroundColor: (isConflicted || disableDateOfFirstAttemptedContact) ? COLORS.DISABLED_BACKGROUND : "" }}
                                            error={isdateOfFirstAttemptedContactInvalid ? true : null}
                                            disabled={(isConflicted || disableDateOfFirstAttemptedContact || isReadOnly) ? true : null}
                                            value={dateOfFirstAttemptedContact}
                                            handleOnChange={onDateOfFirstAttemptedContactChanged}
                                            helperText={isdateOfFirstAttemptedContactInvalid ? INVALID_DATE_FORMAT_MESSAGE : null} />
                                    </Box>
                                    <Box sx={FIELD_SX}>
                                        <SelectorTextField label="Assesment Outcome" placeholder="Assesment Outcome"
                                            select
                                            disabled={isConflicted || isReadOnly ? true : null}
                                            value={assesmentOutcome ? assesmentOutcome?.label : ""}
                                            handleChange={onAssesmentOutcomeChanged}
                                            SelectProps={{ MenuProps: { style: { maxHeight: 250, }, }, }}>
                                            {assesmentOutcomes.map((assesmentOutcome) => (
                                                <MenuItem key={assesmentOutcome.assesmentOutcomeId} value={assesmentOutcome.label}>
                                                    {assesmentOutcome.label}
                                                </MenuItem>))}
                                        </SelectorTextField>
                                    </Box>
                                </Box>

                                {/* ═══ Column 2: In-Custody?, Service Decision Number, Disclosure has been ordered? (legacy layout only), Next Action Date, Assessment Outcome Date ═══ */}
                                <Box sx={columnWithLeftBorderSx(true)}>
                                    <Box sx={FIELD_SX}>
                                        <SelectorTextField label="In-Custody?" placeholder="In-Custody?" style={{ backgroundColor: COLORS.DISABLED_BACKGROUND }} required={true}
                                            select
                                            disabled={true}
                                            value={isInCustody ? isInCustody?.label : ""}>
                                            {yesOrNoSelectionList.map((type) => (
                                                <MenuItem key={type.selectionItemId} value={type.label}>
                                                    {type.label}
                                                </MenuItem>))}
                                        </SelectorTextField>
                                    </Box>
                                    <Box sx={FIELD_SX}>
                                        <TextField label="Service Decision Number" placeholder="Service Decision Number" style={{ backgroundColor: COLORS.DISABLED_BACKGROUND }} required={true}
                                            disabled={true}
                                            value={serviceDecisionNumber}
                                            handleChange={onServiceDecisionNumberChanged}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end' style={{ marginRight: "-8px" }}>
                                                        <StyledButton disabled={interactionCrmId !== "" ? false : true} isViewDetails variant={"outlined"} color="error" onClick={onViewDetailsClicked}>View Details</StyledButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Box>
                                    {usesLegacyLayout && <YesOrNoQuestion question={disclosure.ordered} disabled={isLocked} />}
                                    <Box sx={FIELD_SX}>
                                        <CustomDatePicker label="Next Action Date " placeholder="Next Action Date "
                                            style={{ width: "100%", backgroundColor: (isConflicted || isReadOnly) ? "#ececec" : "" }}
                                            error={isNextActionDateInvalid ? true : null}
                                            disabled={(isConflicted || isReadOnly) ? true : null}
                                            value={nextActionDate}
                                            handleOnChange={onNextActionDateChanged}
                                            helperText={isNextActionDateInvalid ? INVALID_DATE_FORMAT_MESSAGE : null} />
                                    </Box>
                                    <Box sx={FIELD_SX}>
                                        <CustomDatePicker label="Assesment Outcome Date" placeholder="Assesment Outcome Date" style={{ width: "100%", backgroundColor: "#ececec" }}
                                            disabled={true}
                                            value={assesmentOutcomeDate}
                                            handleOnChange={() => { }} //onAssesmentOutcomeDateChanged
                                        />
                                    </Box>
                                </Box>

                                {/* ═══ Column 3: Adult or Youth?, First Court Date, Disclosure Uploaded? (legacy layout only), Status, Likelihood of Imprisonment ═══ */}
                                <Box sx={columnWithLeftBorderSx(false)}>
                                    <Box sx={FIELD_SX}>
                                        <SelectorTextField label="Adult or Youth?" placeholder="Adult or Youth" style={{ backgroundColor: COLORS.DISABLED_BACKGROUND }}
                                            select
                                            disabled={true}
                                            value={adultOrYouth ? adultOrYouth?.label : ""}>
                                            {adultOrYouthStatuses.map((type) => (
                                                <MenuItem key={type.adultOrYouthStatusId} value={type.label}>
                                                    {type.label}
                                                </MenuItem>))}
                                        </SelectorTextField>
                                    </Box>
                                    <Box sx={FIELD_SX}>
                                        <CustomDatePicker label="First Court Date" placeholder="First Court Date" required={false}
                                            style={{ width: "100%", backgroundColor: (isConflicted || disableFirstCourtDate || isInitiallyDisabled) ? COLORS.DISABLED_BACKGROUND : "" }}
                                            error={isFirstCourtDateInvalid ? true : (firstCourtDateError ? true : null)}
                                            disabled={(isConflicted || disableFirstCourtDate || isReadOnly || isInitiallyDisabled) ? true : null}
                                            value={firstCourtDate}
                                            handleOnChange={onFirstCourtDateChanged}
                                            helperText={isFirstCourtDateInvalid ? INVALID_DATE_FORMAT_MESSAGE : null} />
                                    </Box>
                                    {usesLegacyLayout && <YesOrNoQuestion question={disclosure.uploaded} disabled={isLocked} />}
                                    <Box sx={FIELD_SX}>
                                        <SelectorTextField label="Status" placeholder="Status" required={false}
                                            select
                                            error={statusError ? true : null}
                                            disabled={isConflicted || isReadOnly ? true : null}
                                            value={status ? status?.label : ""}
                                            handleChange={onStatusChanged}
                                            helperText={null}>
                                            {offeredStatuses.map((status) => (
                                                status.id > 0 
                                                ?
                                                <MenuItem 
                                                    key={status.id} 
                                                    value={status.label} 
                                                >
                                                    { status.label }
                                                </MenuItem> 
                                                : 
                                                <MenuItem 
                                                    style={{color: COLORS.CLEAR_STATUS_GRAY, fontStyle: "italic"}} 
                                                    key={status.id} 
                                                    value={status.label} 
                                                >
                                                    { 'Clear Status' }
                                                </MenuItem>
                                                ))
                                            }
                                            {
                                                heldStatusHint &&
                                                    <MenuItem key={status.id} value={status.label} disabled>
                                                        {status.label}
                                                    </MenuItem>
                                            }
                                        </SelectorTextField>
                                        {
                                            heldStatusHint && <Tooltip title={heldStatusHint}>
                                                <WarningAmberIcon  fontSize = {"large"}style={{ color: COLORS.ERROR_RED, marginLeft: "5px" }} />
                                          </Tooltip>
                                        }
                                    </Box>
                                    <Box sx={FIELD_SX}>
                                        <SelectorTextField label="Likelihood of Imprisonment" placeholder="Likelihood of Imprisonment" required={(assesmentOutcome && assesmentOutcome !== "") ? true : false}
                                            select
                                            error={imprisonmentLikelihoodError ? true : null}
                                            disabled={isConflicted || isReadOnly ? true : null}
                                            value={imprisonmentLikelihood ? imprisonmentLikelihood?.label : ""}
                                            handleChange={onLikelihoodOfImprisonmentChanged}
                                            helperText={imprisonmentLikelihoodError ? "Likelihood of Imprisonment is required" : null}>
                                            {imprisonmentLikelihoods.map((imprisonmentLikelihood) => (
                                                <MenuItem key={imprisonmentLikelihood.imprisonmentLikelihoodId} value={imprisonmentLikelihood.label}>
                                                    {imprisonmentLikelihood.label}
                                                </MenuItem>))}
                                        </SelectorTextField>
                                    </Box>
                                </Box>

                                {/* ═══ Column 4: Preferred Counsel (Does Client Have Preferred Counsel?, Preferred Lawyer 1/2/3, New Preferred Counsel) ═══ */}
                                <Box sx={columnWithLeftBorderSx(true)}>
                                    <Box sx={FIELD_SX}>
                                        <TextField label="Does Client Have Preferred Counsel?" placeholder="Does Client Have Preferred Counsel" style={{ backgroundColor: "#ececec" }}
                                            disabled={true}
                                            value={doesClientHavePreferredCounsel ? doesClientHavePreferredCounsel?.label : ""}
                                        />
                                    </Box>
                                    {counselVisibility.showClientPreferredLawyer && (
                                        <Box sx={FIELD_SX}>
                                            <TextField label="Client's Preferred Lawyer" placeholder="Client's Preferred Lawyer" style={{ backgroundColor: "#ececec" }}
                                                disabled={true}
                                                value={clientsPreferredLawyer ? (clientsPreferredLawyer.label || clientsPreferredLawyer) : ""}
                                            />
                                        </Box>
                                    )}
                                    {counselVisibility.showClientPreferredLawyer2 && (
                                        <Box sx={FIELD_SX}>
                                            <TextField label="Client's Preferred Lawyer 2" placeholder="Client's Preferred Lawyer 2" style={{ backgroundColor: "#ececec" }}
                                                disabled={true}
                                                value={clientsPreferredLawyer2 ? (clientsPreferredLawyer2.label || clientsPreferredLawyer2) : ""}
                                            />
                                        </Box>
                                    )}
                                    {counselVisibility.showClientPreferredLawyer3 && (
                                        <Box sx={FIELD_SX}>
                                            <TextField label="Client's Preferred Lawyer 3" placeholder="Client's Preferred Lawyer 3" style={{ backgroundColor: "#ececec" }}
                                                disabled={true}
                                                value={clientsPreferredLawyer3 ? (clientsPreferredLawyer3.label || clientsPreferredLawyer3) : ""}
                                            />
                                        </Box>
                                    )}
                                    <Box sx={FIELD_SX}>
                                        <NewPreferredCounselAutocomplete
                                            value={newPreferredCounsel}
                                            onChange={setNewPreferredCounsel}
                                            options={preferredCounselOptions}
                                            displayedCount={displayedOptionsCount}
                                            onLoadMore={() => setDisplayedOptionsCount(prev => Math.min(prev + 50, preferredCounselOptions.length))}
                                            onClose={() => setDisplayedOptionsCount(50)}
                                            disabled={isConflicted || isReadOnly}
                                        />
                                    </Box>
                                </Box>

                            </Box>{/* /section-body */}
                        </Box>
                        <Grid item xs={12} md={12} style={{ margin: "10px 0px 10px 0px", backgroundColor: isDokcetDisabled || isReadOnly ? "#ececec" : null }}>
                            <DocketTable title="Docket Details" dockets={dockets} clientFileId={clientFileId} isDisabled={(isDokcetDisabled || isReadOnly) ? true : false} />
                        </Grid>
                        {/* Story 11029: the business places Disclosure Information after Docket Details: disclosure is ordered after
                            assignment, by legal assistants, and whoever assigns wants Lawyer Information and Docket Details together. */}
                        {usesDisclosureSection && <DisclosureInformationSection disclosure={disclosure} isLocked={isLocked} />}
                        <Grid item xs={12} md={12} style={{ margin: "10px 0px 10px 0px", padding: "5px", border: "1px solid #7F8284", borderRadius: "6px", display: isShowAttachments ? "flex" : "none" }}>
                            <AttachmentList containerName="interactions" recordId={interactionId} title="Attachments (Disclosure provided by court, etc)" isDisabled={(isConflicted || isReadOnly) ? true : false} />
                        </Grid>
                    </Grid>
                </Grid>
            );

        } else {
            return (
                <Grid container style={{ padding: "10px 20px 20px 20px", border: "1px solid #7F8284", margin: "10px 0px 10px 0px", borderRadius: "8px" }}>
                    <Grid item xs={12} md={12} style={{
                        textAlign: "left", font: "normal normal normal 17px/22px Franklin Gothic Medium",
                        letterSpacing: "0px", color: " #000000", opacity: "1", marginBottom: "15px"
                    }}>Client Interaction
                    </Grid>
                    <Grid item xs={12} md={12} style={{
                        textAlign: "left", font: "normal normal 200 15px/17px Franklin Gothic Medium",
                        letterSpacing: "0px", color: " #000000", opacity: "1",
                    }}>** You are not authorized to view these details **
                    </Grid>
                </Grid>
            );
        }
    };

};